import React, {useEffect, useState} from 'react';
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import {useTranslation} from "react-i18next";
import {Title} from "../../../components/components";
import FormButton from "../../../components/forms/FormButton";
import StreamForm from "../../../components/data_products/streams/StreamForm";
import { useCreateDataVendorStreamMutation } from '../../../api/dataVendorStreamApiSlice';
import {useAdminBucket} from "../../../components/utils";


export default function NewDataVendorStream(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const { dataVendorKey } = useParams();
  const [submitButtonProps, setSubmitButtonProps] = useState({})
  const bucket = useAdminBucket(dataVendorKey)

  const handleBack = () => history.push({
    pathname: `/data_vendors/${dataVendorKey}`,
    state: {activeTab: 'streams'}
  });

  const goToStream = (data) => history.push(`/data_vendors/${dataVendorKey}/streams/${data.key}`)

  const [createStream] = useCreateDataVendorStreamMutation()
  const submitProps = {
    handleSubmit: (data) => {
      createStream({...data, dataVendorId: dataVendorKey}).unwrap()
        .then(goToStream)
        .catch(error => {})
    },
    errors: {}
  }

  return (
    <>
      <Title
        main={t("menu.streams")}
        sub={t("new")}
        group={false}
        onBack={handleBack}>
        <FormButton submit {...submitButtonProps}/>
      </Title>
      <StreamForm bucket={bucket} {...submitProps} setSubmitButtonProps={setSubmitButtonProps} />
    </>
  )
}